module.exports = __webpack_public_path__ + "img/trainingDuration.26233066.svg";